import { render } from "./ToolBarMedical.vue?vue&type=template&id=bc9bab2a&scoped=true"
import script from "./ToolBarMedical.vue?vue&type=script&lang=js"
export * from "./ToolBarMedical.vue?vue&type=script&lang=js"

import "./ToolBarMedical.vue?vue&type=style&index=0&id=bc9bab2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9bab2a"]])

export default __exports__